<template>
  <div id="chatRoomRobby">
    <div id="roomListHeader">
      <span>개설된 채팅방 <strong>{{Object.keys(items).length}}</strong>개</span>
      <a @click="openRoomChatWindow('')">채팅방 바로가기</a>
    </div>
    <div id="chatRoomContainer">
      <chatRoom v-for="(item, index) in items" :key="index" :roomInfo="item" />
      <contextMenu />
    </div>
  </div>
</template>

<script>
import chatRoom from './chat-room'
import contextMenu from './chat-contextMenu'
import { getRoomInfo, openRoomChatWindow } from '../util'

export default {
  beforeMount: function () {
    getRoomInfo()
  },
  computed: {
    items () {
      let roominfos = this.$store.getters.roominfo
      return roominfos
    }
  },
  methods: {
    'openRoomChatWindow': openRoomChatWindow
  },
  components: {
    'chatRoom': chatRoom,
    'contextMenu': contextMenu
  }
}

</script>

<style lang="scss">
  #chatRoomRobby {
    position: absolute;
    width: 100%;
    height: calc( 100% - 70px );
    margin-top: 70px;
    font-size: 13px;
    overflow-y: hidden;
    border-bottom: 1px solid #9D9D9D;
    #roomListHeader {
      position: relative;
      top: 0;
      width: 100%;
      height: 23px;
      // border-bottom: 1px solid #d6d6d6;
      background: #f7f7f7;
      z-index: 10;
      span {
        float: left;
        margin: 0 0 0 15px;
        height: 23px;
        line-height: 23px;
        color: #7b7b7b;
        strong {
          padding-left: 2px;
          color: #e82d0c;
        }
      }
      a {
        cursor: pointer;
        float: right;
        margin: 0 9px 0 0;
        height: 23px;
        line-height: 23px;
        color: #7b7b7b;
      }
    }
    #chatRoomContainer {
      overflow-y: auto;
      height: calc( 100% - 26px );
      font-size: 13px;
      border-bottom: 1px solid #D6D6D6;
    }
  }

</style>



// WEBPACK FOOTER //
// chat-room-lobby.vue?6857d033